import { Fragment } from "react";
import { Dialog, Transition } from "@headlessui/react";
import { XMarkIcon } from "@heroicons/react/24/outline";

const GlobalPopUp = ({
  onClose,
  isShowModal,
  popUpData,
}: {
  onClose: () => void;
  isShowModal: boolean;
  popUpData: any;
}) => {
  return (
    <Transition appear show={isShowModal} as={Fragment}>
      <Dialog as="div" className="relative z-50" onClose={() => {}}>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-black bg-opacity-30 transition-opacity" />
        </Transition.Child>

        <div className="fixed inset-0 flex items-center justify-center px-4 py-8">
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0 translate-y-10 scale-95"
            enterTo="opacity-100 translate-y-0 scale-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100 translate-y-0 scale-100"
            leaveTo="opacity-0 translate-y-10 scale-95"
          >
            <Dialog.Panel className="bg-bg-color text-text-color w-full max-w-md rounded-lg shadow-lg p-0">
              {/* Header */}
              <div className="flex items-center justify-between border-b px-6 py-4">
                <Dialog.Title className="text-xl font-semibold">
                  <span
                    dangerouslySetInnerHTML={{ __html: popUpData?.heading }}
                  />
                </Dialog.Title>
                <button
                  onClick={onClose}
                  className="p-2 hover:bg-bg-color border rounded-full border-text-color transition"
                >
                  <XMarkIcon className="h-5 w-5 text-text-color" />
                </button>
              </div>
              {/* Body */}
              <div className="px-6 py-5">
                <span
                  dangerouslySetInnerHTML={{ __html: popUpData?.description }}
                />
              </div>
            </Dialog.Panel>
          </Transition.Child>
        </div>
      </Dialog>
    </Transition>
  );
};

export default GlobalPopUp;
